export const convertMillisecondsToReadableFormat = (time: number): string => {
    const h = Math.floor(time/1000/60/60);
    const m = Math.floor((time/1000/60/60 - h)*60);
    const s = Math.floor(((time/1000/60/60 - h)*60 - m)*60);

    return `${m < 10 ? '0': ''}${m}:${s < 10 ? '0': ''}${s}`;
};
